module.exports = __webpack_public_path__ + "public/img/zhifu.87a09ab5.jpg";